import { useEffect, useCallback } from 'react';
import oneTrustManager from 'utils/oneTrustManager';

export const useOneTrust = () => {
  const initializeOneTrust = useCallback(() => {
    oneTrustManager.initialize();
  }, []);

  const showSettings = useCallback(() => {
    oneTrustManager.showSettings();
  }, []);

  useEffect(() => {
    // Initialize OneTrust when the component mounts
    initializeOneTrust();

    // Listen for route changes in Gatsby
    const handleRouteChange = () => {
      // Only reinitialize if OneTrust is ready
      setTimeout(() => {
        if (oneTrustManager.isReady()) {
          oneTrustManager.reinitialize();
        }
      }, 1000);
    };

    // Add event listener for Gatsby route changes
    if (typeof window !== 'undefined') {
      window.addEventListener('popstate', handleRouteChange);

      // Also listen for Gatsby's internal route change events
      if (window.__GATSBY_ROUTE_CHANGE_START) {
        window.addEventListener('gatsby-route-change', handleRouteChange);
      }
    }

    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('popstate', handleRouteChange);
        if (window.__GATSBY_ROUTE_CHANGE_START) {
          window.removeEventListener('gatsby-route-change', handleRouteChange);
        }
      }
    };
  }, [initializeOneTrust]);

  return { showSettings, initializeOneTrust };
};
